/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Col_CountInputs */

const cs_reports_col_count = /** @type {(inputs: Reports_Col_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Počet`)
};

const en_reports_col_count = /** @type {(inputs: Reports_Col_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Count`)
};

/**
* | output |
* | --- |
* | "Count" |
*
* @param {Reports_Col_CountInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const reports_col_count = /** @type {((inputs?: Reports_Col_CountInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Col_CountInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_col_count(inputs)
	return cs_reports_col_count(inputs)
});